export const CATEGORY_QUERY_STRING_KEY = "category";
export const TOPIC_QUERY_STRING_KEY = "topic";
export const QUESTION_QUERY_STRING_KEY = "question";
export const SEARCH_QUERY_STRING_KEY = "q";
